<template>
  <div class="md:grid grid-cols-2 gap-5">
    <div
      v-for="(group, key) in amenities"
      :key="key"
    >
      <p
        v-if="showCategories"
        :key="`${key}-title`"
        class="text-gray-500 text-sm/5 font-semibold"
      >
        {{ t(`amenities.categories.${key}`) }}
      </p>

      <slot :name="`${key}-start`" />

      <TCheckbox
        v-for="(value, amenityKey) in group"
        :id="`checkbox-${amenityKey}`"
        :key="`${key}-${amenityKey}`"
        :model-value="value"
        class="my-2 md:my-1"
        :name="`checkbox-${amenityKey}`"
        :label="t(`amenities.${amenityKey}`)"
        @update:model-value="(value) => handleAmenityChange(amenityKey, Boolean(value))"
      />

      <slot :name="`${key}-end`" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AMENITIES, AMENITIES_CATEGORIES } from '~/constants/amenities'

defineProps<{
  showCategories?: boolean
}>()

const model = defineModel<AMENITIES[]>({ default: () => ([]) })

const { t } = useI18n()

const amenities = computed<Partial<Record<AMENITIES_CATEGORIES, Partial<Record<AMENITIES, boolean>>>>>(() => ({
  Temperature: {
    AirConditioner: model.value.includes('AirConditioner'),
    Heater: model.value.includes('Heater'),
  },

  Bathroom: {
    InsideShower: model.value.includes('InsideShower'),
    OutsideShower: model.value.includes('OutsideShower'),
    Toilet: model.value.includes('Toilet'),
  },

  Kitchen: {
    Refrigerator: model.value.includes('Refrigerator'),
    Stove_Range: model.value.includes('Stove_Range'),
    Microwave: model.value.includes('Microwave'),
    KitchenSink: model.value.includes('KitchenSink'),
    DiningTable: model.value.includes('DiningTable'),
  },

  Other: {
    Family_kidfriendly: model.value.includes('Family_kidfriendly'),
  },
}))

function handleAmenityChange(amenity: AMENITIES, value: boolean) {
  if (value) {
    model.value = [...model.value, amenity]
  }
  else {
    model.value = model.value.filter((a) => a !== amenity)
  }
}
</script>

<i18n src="~~/i18n/locales/common/amenities.json" lang="json" />
